




import { defineComponent, PropType, watch } from '@vue/composition-api'
import { useActions, useMutations, useState } from 'vuex-composition-helpers'

import { IConfig } from '../models/config-interface'

import ShowAllComponent from './ShowAll/ShowAll.vue'
import ImpersonationComponent from './Impersonation/Impersonation.vue'

export default defineComponent({
    name: 'ContentSwitch',
    components: {
        ImpersonationComponent,
        ShowAllComponent
    },
    props: {
        widgetType: {
            type: String,
            required: true,
            validator: (value: string) => {
                return ['ShowAll', 'Impersonation'].includes(value)
            }
        },
        configRaw: {
            type: Object as PropType<IConfig>,
            required: true
        }
    },
    setup: (props) => {
        const { init } = useActions(['init'])
        const { settings } = useState(['settings'])
        const { setCookie } = useMutations(['setCookie'])
        const widgetComponent = retrieveComponent()

        function retrieveComponent() {
            switch (props.widgetType) {
                case "ShowAll":
                    return 'show-all-component'
                case "Impersonation":
                    return 'impersonation-component'
                default:
                    return ''
            }
        }

        init()
        
        watch(settings.value, () => { setCookie() })

        return {
            settings,
            widgetComponent
        }
    }
})
